/* Broodnodig koopflow (19 okt 2026)
   1. Zwevende koopbalk (snippets/bn-koopflow.liquid): volgt het bundelblok en drukt op de echte bundelknop.
   2. Winkelwagen-lade (assets/bn-cart.js): bevestiging na toevoegen en meldingen in beeld in plaats van alert(). */
(function () {
  if (window.BNKoopflow) return;
  var T = window.BNKoopflowText || { one: 'stuk', many: 'stuks', extra: 'extra', off: 'korting', added: 'Toegevoegd', adding: 'Toevoegen …', addedCart: 'Toegevoegd aan je winkelwagen', error: 'Er ging iets mis. Probeer het opnieuw.', close: 'Sluiten', pct: '%' };
  var html = document.documentElement;

  /* ---------- Melding in beeld ---------- */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bn-kf-toast';
      toastEl.setAttribute('role', 'alert');
      toastEl.innerHTML = '<span></span><button type="button" aria-label="' + T.close + '">×</button>';
      toastEl.querySelector('button').addEventListener('click', function () { toastEl.classList.remove('is-on'); });
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = msg || T.error;
    clearTimeout(toastT);
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 6000);
  }
  window.alert = function (msg) { toast(String(msg || '')); };

  /* ---------- Bevestiging in de lade na toevoegen ---------- */
  var addedAt = 0;
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r.ok) { addedAt = Date.now(); setTimeout(confirmAdded, 0); } }).catch(function () {});
      }
      return p;
    };
  }
  function confirmAdded() {
    if (Date.now() - addedAt > 6000) return;
    var panel = document.querySelector('#bnCartDrawer .bn-cd__panel');
    if (!panel || panel.querySelector('.bn-cd__added') || !panel.querySelector('[data-key]')) return;
    var head = panel.querySelector('.bn-cd__head');
    if (!head) return;
    var el = document.createElement('div');
    el.className = 'bn-cd__added';
    el.setAttribute('role', 'status');
    el.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
    el.querySelector('span').textContent = T.addedCart;
    head.insertAdjacentElement('afterend', el);
  }
  function watchDrawer() {
    var slot = document.querySelector('#bnCartDrawer [data-bn-cd-slot]');
    if (!slot) return false;
    new MutationObserver(confirmAdded).observe(slot, { childList: true });
    return true;
  }

  /* ---------- Zwevende koopbalk ---------- */
  /* Controle: alleen met ?bn_debug=1 in de adresbalk staat de status van de balk linksboven. */
  var themeRole = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var DEBUG = /[?&]bn_debug=1/.test(location.search);
  var dbgEl = null;
  function dbg(msg) {
    if (!DEBUG) return;
    if (!dbgEl) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:6px;top:6px;z-index:2147483647;margin:0;padding:6px 8px;max-width:90vw;white-space:pre-wrap;background:rgba(0,0,0,.8);color:#fff;font:11px/1.35 monospace;border-radius:6px;pointer-events:none';
      document.body.appendChild(dbgEl);
    }
    dbgEl.textContent = 'koopbalk: ' + msg;
  }

  function initBar(attempt) {
    attempt = attempt || 0;
    var bar = document.querySelector('[data-bn-kb]');
    if (!bar) { dbg('geen balk in de html (geen productpagina?)'); return; }
    /* Het zichtbare bundelblok met koopknop. Let op: het bundelblok staat binnen het productformulier van het thema,
       dus de browser laat het eigen <form data-bn-form> weg (een formulier in een formulier bestaat niet).
       Daarom zoeken we de knop zelf en drukken we daarop, precies zoals een klant dat doet. */
    var BTN = '[data-bn-add], .bn-bundle-button';
    /* Het bundelblok steeds opnieuw opzoeken: als het thema het blok later vervangt of dubbel heeft (mobiel/desktop),
       werkt de balk altijd met het blok dat nu zichtbaar is. */
    function findBundle() {
      var all = document.querySelectorAll('.bn-bundle-atc'), vis = null, any = null;
      for (var i = 0; i < all.length; i++) {
        if (!all[i].querySelector(BTN)) continue;
        if (!any) any = all[i];
        if (!vis && all[i].getClientRects().length) vis = all[i];
      }
      return vis || any;
    }
    var bundle = findBundle();
    var realBtn = bundle && bundle.querySelector(BTN);
    /* Alleen met bundelblok (zelfde knop-logica); het blok kan later in de pagina komen, dus even opnieuw proberen */
    if (!realBtn) {
      if (attempt < 20) { dbg('wacht op bundelblok (' + attempt + ')'); setTimeout(function () { safeInit(attempt + 1); }, 500); return; }
      dbg('geen bundelblok gevonden, oude balk blijft');
      bar.parentNode.removeChild(bar);
      return;
    }
    function refresh() {
      var nb = findBundle();
      if (nb) { bundle = nb; realBtn = nb.querySelector(BTN) || realBtn; }
    }
    html.classList.add('bn-kb-page');

    var pct = parseInt(bar.getAttribute('data-pct'), 10) || 0;
    var nEl = bar.querySelector('[data-bn-kb-n]');
    var minusBtn = bar.querySelector('[data-bn-kb-minus]');
    var plusBtn = bar.querySelector('[data-bn-kb-plus]');
    var priceEl = bar.querySelector('[data-bn-kb-price]');
    var wasEl = bar.querySelector('[data-bn-kb-was]');
    var tagEl = bar.querySelector('[data-bn-kb-tag]');
    var btn = bar.querySelector('[data-bn-kb-add]');
    var label = bar.querySelector('[data-bn-kb-label]');
    var labelText = label.textContent;

    function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
    /* Naam zoals op de pagina (in DE al vertaald door de bn-de-laag), deel na het streepje */
    var h1 = document.querySelector('h1');
    var nameEl = bar.querySelector('.bn-kb__name');
    if (h1 && nameEl && txt(h1)) { var parts = txt(h1).split(/\s[-–]\s/); nameEl.textContent = parts[parts.length - 1]; }
    function opt3v() { return bundle.querySelector('[data-bn-option][data-qty="3v"]'); }
    function qty() {
      refresh();
      var opt = bundle.querySelector('[data-bn-option].active');
      /* n99: rij "3v" = vast 3 stuks; de rij data-qty="3" met − / + is 4+ (als er een 3v-rij is) */
      var dq = opt ? opt.getAttribute('data-qty') : '1';
      var n = dq === '3v' ? 3 : (opt ? parseInt(dq, 10) || 1 : 1);
      if (dq === '3') {
        var num = bundle.querySelector('[data-bn-option][data-qty="3"] [data-qty-number]');
        var min = opt3v() ? 4 : 3;
        n = Math.max(min, parseInt(txt(num), 10) || min);
      }
      return n;
    }
    function sync() {
      var n = qty();
      var opt = bundle.querySelector('[data-bn-option].active');
      nEl.textContent = n;
      minusBtn.disabled = n <= 1;
      var p = opt && opt.querySelector('.bn-bundle-prices strong');
      var w = opt && opt.querySelector('.bn-bundle-prices s');
      if (p && txt(p)) priceEl.textContent = txt(p);
      if (wasEl) { var wt = txt(w); wasEl.textContent = wt; wasEl.hidden = !wt; }
      var stack = (n >= 4 && opt3v()) ? 15 : (n >= 3 ? 10 : (n === 2 ? 5 : 0));
      bar.classList.toggle('is-stack', !!stack);
      /* "25% korting", "25% + 5% extra korting", "25% + 10% extra korting" */
      var main = pct ? pct + T.pct + (stack ? ' + ' + stack + T.pct + ' ' + T.extra : '') : (stack ? '+' + stack + T.pct + ' ' + T.extra : '');
      tagEl.innerHTML = '<span></span><span class="bn-kb__off"></span>';
      tagEl.firstChild.textContent = main;
      tagEl.lastChild.textContent = ' ' + (T.off || '');
      tagEl.hidden = !main;
      /* Te krap: eerst de doorgestreepte prijs weg, daarna het woord "korting" */
      bar.classList.remove('is-tight', 'is-tighter');
      var row = tagEl.parentNode;
      function over() { return row && row.scrollWidth > row.clientWidth + 1; }
      if (over()) bar.classList.add('is-tight');
      if (over()) bar.classList.add('is-tighter');
    }
    /* Balk volgt het bundelblok: elke klik, toets of wijziging in een bundelblok, en voor de zekerheid elke 400 ms */
    ['click', 'keyup', 'change', 'input'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (e.target && e.target.closest && e.target.closest('.bn-bundle-atc')) setTimeout(sync, 0);
      }, true);
    });
    var lastN = -1;
    setInterval(function () { var n = qty(); if (n !== lastN) { lastN = n; sync(); } }, 400);
    sync();

    /* Aantal kiezen in de balk: zet dezelfde keuze in het bundelblok (1, 2, 3 en daarboven via − / +), zonder te scrollen */
    var lastAct = '';
    function opt(q) { return bundle.querySelector('[data-bn-option][data-qty="' + q + '"]'); }
    function pick(o) {
      o.click();
      /* Reserve als het bundelblok de klik niet oppakt: keuze en aantal zelf zetten */
      if (!o.classList.contains('active')) {
        bundle.querySelectorAll('[data-bn-option]').forEach(function (x) { x.classList.remove('active'); });
        o.classList.add('active');
        var inp = bundle.querySelector('[data-bn-quantity]');
        if (inp) inp.value = String(qty());
        lastAct += ' (reserve)';
      }
    }
    function setQty(target) {
      var cur = qty(), guard = 0;
      if (target < 1 || target === cur) return;
      if (target <= 2) { if (opt(target)) pick(opt(target)); }
      else if (target === 3 && opt3v()) { pick(opt3v()); }
      else {
        var three = opt(3), plus = three && three.querySelector('[data-plus]'), minus = three && three.querySelector('[data-minus]');
        if (!three) return;
        if (cur < 3 || (opt3v() && !three.classList.contains('active'))) pick(three);
        while (qty() < target && plus && guard++ < 50) plus.click();
        while (qty() > target && minus && guard++ < 50) minus.click();
      }
      sync();
    }
    /* Vangen op window (vóór andere scripts), zodat geen ander script de klik kan wegnemen */
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-bn-kb-minus], [data-bn-kb-plus]');
      if (!t || !bar.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      var up = t.hasAttribute('data-bn-kb-plus');
      lastAct = (up ? '+' : '−') + ' van ' + qty();
      setQty(qty() + (up ? 1 : -1));
      lastAct += ' naar ' + qty();
    }, true);

    /* Toevoegen = de echte bundelknop (zelfde variant, aantal, personalisatie en lade) */
    var clickAt = 0;
    btn.addEventListener('click', function () {
      refresh();
      clickAt = Date.now();
      btn.classList.add('is-busy');
      label.textContent = T.adding;
      realBtn.click();
    });
    function done(ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-done');
        label.textContent = '✓ ' + T.added;
        setTimeout(function () { btn.classList.remove('is-done'); label.textContent = labelText; }, 2500);
      } else {
        label.textContent = labelText;
      }
    }
    setInterval(function () {
      /* Klaar zodra de winkelwagen het toevoegen bevestigt; na 6 seconden zonder bevestiging terug naar de gewone knop */
      if (!btn.classList.contains('is-busy')) return;
      if (addedAt >= clickAt) done(true);
      else if (Date.now() - clickAt > 6000) done(false);
    }, 250);

    /* Zichtbaarheid: niet bovenaan, niet terwijl de koopknop van het bundelblok in beeld is, niet bij lade, pop-up of toetsenbord.
       Positie uit getBoundingClientRect, zodat het ook werkt als de pagina in body scrolt in plaats van in window. */
    function scrolled() {
      var se = document.scrollingElement || html;
      return Math.max(window.pageYOffset || 0, se.scrollTop || 0, html.scrollTop || 0, document.body.scrollTop || 0);
    }
    function bundleInView() {
      var t = realBtn.getClientRects().length ? realBtn : bundle;
      var r = t.getBoundingClientRect();
      if (!r.width && !r.height) return false;
      return r.top < window.innerHeight - 40 && r.bottom > 60;
    }
    function modalOpen() {
      var m = document.getElementById('bnPersonalisatieModal');
      return !!(m && m.classList.contains('active'));
    }
    function typing() {
      var a = document.activeElement;
      return !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !bar.contains(a));
    }
    function update() {
      var on = scrolled() > 200 && !bundleInView() && !html.classList.contains('bn-cd-lock') && !modalOpen() && !typing();
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      html.classList.toggle('bn-kb-on', on);
      if (DEBUG) {
        var r = bar.getBoundingClientRect();
        dbg((on ? 'AAN' : 'uit') + ' | scroll ' + Math.round(scrolled()) + ' | bundel in beeld ' + bundleInView() + ' | lade ' + html.classList.contains('bn-cd-lock') + ' | pop-up ' + modalOpen() + ' | typen ' + typing() + ' | balk top ' + Math.round(r.top) + '/' + window.innerHeight + '\nbundels ' + document.querySelectorAll('.bn-bundle-atc').length + ' | aantal ' + qty() + ' | laatste knop ' + (lastAct || '-'));
      }
    }
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', function () { sync(); update(); });
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', function () { setTimeout(update, 50); });
    new MutationObserver(update).observe(html, { attributes: true, attributeFilter: ['class'] });
    var modal = document.getElementById('bnPersonalisatieModal');
    if (modal) new MutationObserver(update).observe(modal, { attributes: true, attributeFilter: ['class'] });
    setInterval(update, 800);
    update();
  }

  function safeInit(attempt) {
    try { initBar(attempt); } catch (e) {
      /* Bij een fout terug naar de oude balk uit het template */
      html.classList.remove('bn-kb-page', 'bn-kb-on');
      var b = document.querySelector('[data-bn-kb]');
      if (b) b.parentNode.removeChild(b);
      dbg('fout: ' + e.message);
      if (window.console) console.warn('bn-koopflow', e);
    }
  }
  function start() {
    dbg('script geladen, thema ' + (themeRole || '?'));
    safeInit(0);
    if (!watchDrawer()) {
      var tries = 0, iv = setInterval(function () { if (watchDrawer() || ++tries > 40) clearInterval(iv); }, 250);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.BNKoopflow = { toast: toast };
})();
